import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appUserLicense]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UserLicenseDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class UserLicenseDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^[a-zA-Z0-9- ]*$/.test(control.value)
     ? null
     : { invalid : true };
 }
}